import { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DebugActions from '../../../../Modules/Redux/Global/Debug/DebugActions';
import DebugSelectors from '../../../../Modules/Redux/Global/Debug/DebugSelectors';
import { Box } from '../../Components/Box/Box';
import { BoxSection } from '../../Components/BoxSection/BoxSection';
import { NavigationBar } from '../../Components/NavigationBar/NavigationBar';
import { PageLayout } from '../../Components/PageLayout/PageLayout';
import { Toggle } from '../../Components/Toggle/Toggle';
import { DiscordWidget } from './DiscordWidget/DiscordWidget';

export const FeedbackPage: FunctionComponent = () => {
  const dispatch = useDispatch();
  const isDebugMode = useSelector(DebugSelectors.isDebugMode);

  function toggleDebugMode(isEnabled: boolean): void {
    dispatch(DebugActions.setDebugMode(isEnabled));
  }

  return (
    <div>
      <NavigationBar title="Feedback" />
      <PageLayout>
        <div className="h-stack space-x-4 text-text">
          <div className="v-stack space-y-2">
            <Box>
              <BoxSection>
                <p>Thanks for using Project Odyssey ! You can give your feedback and report bugs on the discord.</p>
              </BoxSection>
            </Box>

            <Box className="space-y-4">
              <BoxSection title="Report bugs">
                <p>Use the issues channel to report your bugs</p>
              </BoxSection>
              <BoxSection title="Suggestions">
                <p>Use the suggestions channel to give suggestions</p>
              </BoxSection>
              <BoxSection title="Troubleshoots">
                <div className="space-y-2">
                  <p>If you have issues with the app, please verify that:</p>
                  <ul className="ml-5 list-disc">
                    <li>Your capture card is correctly connected to your computer.</li>
                    <li>
                      You have allowed access to camera. This is required to find connected devices to you computer.
                    </li>
                    <li>You use Google Chrome. Some features may not work properly on other web browsers.</li>
                  </ul>
                  <p>If you still encounter issues, please report it on the issues channel on the discord.</p>
                </div>
              </BoxSection>
            </Box>

            <Box>
              <BoxSection>
                <div className="v-stack space-y-2">
                  <div className="h-stack justify-between">
                    <h4>Debug mode</h4>
                    <Toggle isEnabled={isDebugMode} onChange={toggleDebugMode} />
                  </div>
                  <h5 className="text-sm text-text-secondary leading-4">
                    Activate this mode to help developers debug your issues.
                  </h5>
                </div>
              </BoxSection>
            </Box>
          </div>

          <DiscordWidget />
        </div>
      </PageLayout>
    </div>
  );
};
